export const AppConfig = {
  localStorageKey: "loggedInUser"
}
